import classNames from 'classnames';
import * as inflection from 'inflection';
import React from 'react';
import Button from '../components/Button';
import { BEACON_SEARCH_POSTS } from '../constants/onboarding';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';
import * as styles from './SearchResultTypeFilter.module.scss';

interface SearchResultTypeFilterProps {
  type?: string;
  setType: (type?: string) => void;
  vertical?: boolean;
  countsByType: Record<string, number> & { null?: number };
}

const SearchResultTypeFilter = ({
  type,
  setType,
  vertical,
  countsByType,
}: SearchResultTypeFilterProps) => {
  const { null: otherResultCount, ...resultCounts } = countsByType;

  const typeNames = Object.keys(resultCounts)
    .filter((name) => name !== 'template') // TODO: Unhide when supported
    .toSorted((l, r) => {
      if (l < r) return -1;
      if (l > r) return 1;
      return 0;
    });

  if (otherResultCount) {
    typeNames.push('other');
  }

  // when user changes the search term, type filter are not changed,
  // make sure the selected filter will always be shown.
  if (type && !typeNames.find((t) => t === type)) {
    typeNames.push(type);
  }

  const types = typeNames.map((name) => ({
    name,
    count: resultCounts[name] || 0,
  }));

  return (
    <div
      className={classNames(styles.filterNav, { [styles.vertical]: vertical })}
    >
      <Button
        className={classNames(styles.filterNavItem, { [styles.active]: !type })}
        onClick={() => setType(undefined)}
      >
        All
      </Button>
      {types.map(({ name, count }) => (
        <TutorialBeacon
          key={name}
          hide={name !== 'post'}
          id={BEACON_SEARCH_POSTS}
        >
          {(beaconProps) => (
            <Button
              className={classNames(styles.filterNavItem, {
                [styles.active]: name === type,
              })}
              onClick={() => setType(name)}
            >
              <span {...beaconProps}>
                {inflection.humanize(inflection.inflect(name, count))}
                {name !== 'comment' ? ` (${count})` : ''}
              </span>
            </Button>
          )}
        </TutorialBeacon>
      ))}
    </div>
  );
};

export default SearchResultTypeFilter;
